<template>
  <h2>{{ text }}</h2>
</template>

<script>
export default {
  name: "Heading",
  props: {
    text: {
      type: String,
      default: ""
    }
  }
};
</script>

<style lang="scss" scoped>
h2 {
  font-size: 40px;
  margin-bottom: 24px;
  text-align: center;
}
</style>
